import { KibsiCrudClient } from './crud-base';
export class SubscriptionKibsiClient extends KibsiCrudClient {
    constructor(params) {
        super(params, 'realtime-data');
    }
    list(deploymentId, requestConfig) {
        return this.get(`/deployments/${deploymentId}/subscriptions`, requestConfig);
    }
    read(entityId, requestConfig) {
        return this.get(`/subscriptions/${entityId}`, requestConfig);
    }
    create(entity, requestConfig) {
        return this.post('/subscriptions', entity, requestConfig);
    }
    update(entity, requestConfig) {
        return this.put(`/subscriptions/${entity.subscriptionId}`, entity, requestConfig);
    }
    delete(entityId, requestConfig) {
        return this.del(`/subscriptions/${entityId}`, requestConfig);
    }
}
//# sourceMappingURL=subscription.js.map